// extracted by mini-css-extract-plugin
export default {"question_heading":"Frequentlyquestion_question_heading__qU7yJ"};